import { Component, Input, OnInit } from '@angular/core';
import { SingleCompany } from '../../../_shared/interfaces';
import {AlertService, ContactsStoreService, IAlertType} from '../../../_shared/services';
import {NgIf} from "@angular/common";
import {ClrModalModule} from "@clr/angular";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-contact-card',
  standalone: true,
  imports: [
    NgIf,
    ClrModalModule,
    RouterLink
  ],
  templateUrl: './contact-card.component.html',
  styleUrl: './contact-card.component.sass'
})
export class ContactCardComponent implements OnInit {
  company: SingleCompany | null = null;
  companyid: number = 0;
  public makeACall = false;

  @Input() childMessage: number = 0;

  constructor(
    private css: ContactsStoreService,
    private alertDispatcher: AlertService,
  ) { }

  ngOnInit() {
    this.loadSingleContact(this.childMessage);
  }

  loadSingleContact(contactID: number) {
    this.css.getSingleCompany(contactID)
      .subscribe({
        next: res => {
          if (!res || !res.object || res.object.length === 0) {
            this.alertDispatcher.alertConfig.message = 'Keine Firmendaten gefunden!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
            return;
          }
          this.company = res.object[0];
        },
        complete: () => {},
        error: () => {
          return
        }
      });
  }

  callUrl(phoneNumber: string) {
    const normalizedPhoneNumber = phoneNumber.replace(/[^\d+]/g, '');
    return `tel:${normalizedPhoneNumber}`;
  }

  startCall(phoneNumber: string) {
    window.location.href = this.callUrl(phoneNumber);
  }
}
